import React, { Fragment, useEffect } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { useTranslation } from "react-i18next";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`scrollable-auto-tabpanel-${index}`}
      aria-labelledby={`scrollable-auto-tab-${index}`}
      {...other}
    >
      <Box p={3}>{children}</Box>
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired
};

function a11yProps(index) {
  return {
    id: `scrollable-auto-tab-${index}`,
    "aria-controls": `scrollable-auto-tabpanel-${index}`
  };
}

const useStyles = makeStyles({
  root: {
    flexGrow: 1,
    width: "100%",
    zIndex: 2,
    top: props => props.isSticky ? "0px" : "",
    position: props => props.isSticky ? "sticky" : "fixed"
  },
  appBar: {
    height: "48px"
  },
  content: {
    margin: 0,
    padding: 0,
    paddingTop: props => props.isSticky ? "8px" : "48px",
    height: "100%"
  },

  hidden: {
    display: "none"
  }
});

export default function ScrollableTabs(props) {
  const classes = useStyles(props);
  const [value, setValue] = React.useState(props.value || 0);

  function handleChange(event, newValue) {
    setValue(newValue);

    if (props.handleTabChange) {
      props.handleTabChange(newValue);
    }
  }

  return (
    <Box style={{ position: "relative", width: "100%", height: "100%" }}>
      <AppBar className={classes.root} position="static" color="default" elevation={props.elevation != null ? props.elevation : 4}>
        <Tabs
          value={props.value != null ? props.value : value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {props.tabs.map(tab => {
            return <Tab key={tab.key} label={tab.name} />;
          })}
        </Tabs>
      </AppBar>

      {props.tabs.map((tab, index) => {
        const indexValue = props.value != null ? props.value : value
        if (index === indexValue) {

          return <div key={tab.key} className={classes.content}>{tab.content}</div>;
        }
      })}
    </Box>
  );
}
